import React from "react";
import Loader from "components/loader";
import useToggle from "hooks/useToggle";
import { useDispatch } from "react-redux";
import { addCartItems } from "actions/cart";
import { trackAddToCart } from "services/analytics";
import { isMobile } from "utils/device-detect";
import { useGlobalContext } from "context/global";
import { openCart } from "slices/cart";

const AddAllToCartButton = ({ className, products, atcText }) => {
	const { translation } = useGlobalContext();
	const [loading, toggleLoading] = useToggle();
	const dispatch = useDispatch();
	const isMobileView = isMobile();

	const addCollectionItems = async () => {
		toggleLoading();
		const availableProducts = products.map(({ variant }) => {
			if (["available", "one-time"].includes(variant.stock))
				return {
					id: variant.id,
					oneTime: variant.stock === "one-time"
				};

			return false;
		}).filter(Boolean);
		await dispatch(addCartItems(availableProducts));
		!isMobileView && dispatch(openCart());
		toggleLoading();
		trackAddToCart(products);
	};

	return (
		loading ?
			<div className="h-9">
				<Loader ring={true} />
			</div> :
			<button onClick={addCollectionItems} className={`btn-primary px-3 py-2 rounded-3xl ${className}`}>
				{atcText ?? <>+ {translation.product?.addAllToCart}</>}
			</button>
	);
};

export default AddAllToCartButton;